// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"831d1e0a","732":"2afa4d97","977":"6893cf89"}[chunkId] + ".chunk.js";
};